import { CASE_TYPE_FIELD_OPTIONS } from '../const';
import { SupportFormSelectField } from './SupportFormSelectField';

export const CaseTypeField = () => (
  <SupportFormSelectField
    name="type"
    label="Case type"
    selectProps={{
      options: Object.values(CASE_TYPE_FIELD_OPTIONS),
      placeholder: 'Select a case type',
    }}
  />
);
